export enum ROLE {
  EDITOR = "EDITOR",
  PUBLISHER = "PUBLISHER",
  BANKER = "BANKER",
  SUPPORT = "SUPPORT",
}
